import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { css } from '@emotion/core';
import moment from 'moment';

import {
  productClick,
  addToCartEvent,
  pushRemarketingEvent,
} from '../lib/gaEnhancedEcommerce';
import {
  primary_s5_l55,
  primary_s20_l70_a025,
  primary_s15_l20,
  primary_s5_l90,
} from '../lib/colors';
import A from '../Anchor/Anchor';
import Price from '../Price/Price';
import Cart from '../Icons/Cart';
import {
  addToCart,
  isInCart,
  quantityInCart,
  getMaxAddable,
} from '../../../redux/modules/cart';
import Timer from '../Timer/Timer';
import { ga4AddToCart, ga4SelectItem } from '../lib/ga4EnhancedEcommerce';
import { fkmxAddToCart, fkmxSelectItem } from '../lib/farmakomMetrics';
import { criteoAddToCart } from '../lib/criteo';
import {
  gtmToGa4AddToCart,
  gtmToGa4SelectItem,
} from '../lib/gtmEnhancedEcommerce';

import './ProductThumbnail.scss';
import { ImageDispatcher } from '../ImageDispatcher/ImageDispatcher';

class ProductThumbnail extends Component {
  addToCart = event => {
    event.preventDefault();
    const product = this.props.product;
    this.props.addToCart(product, 1);

    if (this.props.advancedGa) {
      addToCartEvent({
        id: product.code || '',
        name: product.name,
        category: product.categoryName,
        brand: product.brand,
        price: product.price,
        quantity: 1,
      });
    }
    // GTM ADD TO CART
    if (this.props.hasGoogleTagManager) {
      gtmToGa4AddToCart(product, this.props.ga4ListInfo);
    }
    // GA4 ADD TO CART
    if (this.props.hasGoogleAnalytics4Advanced) {
      ga4AddToCart(product, this.props.ga4ListInfo);
    }
    // FKMX ADD TO CART
    if (this.props.hasFarmakomMetrics) {
      fkmxAddToCart(product, this.props.ga4ListInfo);
    }

    // CRITEO ADD TO CART
    if (this.props.hasCriteo) {
      // const iubenda = new IubendaCookieSolution(
      //   this.props.hasIubendaCookieSolution
      // );
      // iubenda.proceedIfHasConsent(() =>
      //   this.renderCriteoTag({ ...product, quantity: 1 })
      //   );
      this.renderCriteoTag({ ...product, quantity: 1 });
    }
  };

  renderCriteoTag = async product => {
    // <!-- Criteo ARMAGEDDON Add To Cart Tag -->
    const user = this.props.user.data;
    const email = (user && user.email) || '';
    const zipcode = (user && user.shipping && user.shipping.zipcode) || '';

    criteoAddToCart(this.props.criteoAccountId, { email, zipcode }, [product]);
    // <!-- END Criteo Basket/Cart Tag -->
  };

  getPath = () => {
    const product = this.props.product;
    return `/${product.type}/${product.categorySeoName}/${
      product.subcategorySeoName ? product.subcategorySeoName : '_'
    }/${encodeURIComponent(product.seoName)}`;
  };

  goToProduct = event => {
    event.preventDefault();
    const product = this.props.product;

    const productGA = {
      id: product.code,
      name: product.name,
      category: product.categoryName,
      brand: product.brand,
    };
    // GOOGLE ANALYTICS: PRODUCT CLICK
    if (this.props.advancedGa) {
      productClick(productGA, this.props.list);
    }
    // REMARKETING DINAMICO
    if (this.props.hasDynamicRemarketing) {
      pushRemarketingEvent('product', product);
    }
    // GTM SELECT ITEM
    if (this.props.hasGoogleAnalytics4Advanced) {
      gtmToGa4SelectItem(product, this.props.ga4ListInfo);
    }
    // GA4 SELECT ITEM
    if (this.props.hasGoogleAnalytics4Advanced) {
      ga4SelectItem(product, this.props.ga4ListInfo);
    }
    // FKMX SELECT ITEM
    if (this.props.hasFarmakomMetrics) {
      fkmxSelectItem(product, this.props.ga4ListInfo);
    }

    this.props.router.push(this.getPath());
  };

  renderAvailabilityClass() {
    let { product, sellProductsOutOfStock } = this.props;

    if (sellProductsOutOfStock && !product.maxNumInCart) {
      return 'available';
    }

    const minAvailable = product.maxNumInCart
      ? Math.min(product.stock, product.maxNumInCart)
      : product.stock;

    if (minAvailable === 0) {
      return 'not-available';
    } else if (minAvailable > 0 && minAvailable < 10) {
      return 'availability-warning';
    } else {
      return '';
    }
  }

  renderAvailability() {
    let { product, sellProductsOutOfStock } = this.props;

    // è presente una data di disponibilità
    if (!!product.availabilityDate) {
      // la data è nel futuro
      if (new Date(product.availabilityDate) > new Date()) {
        return (
          'Spedizione dal ' +
          moment(new Date(product.availabilityDate)).format('DD-MM-YYYY')
        );
      }
    }

    // VENDE FUORI STOCK
    if (sellProductsOutOfStock || !!product.sellProductsOutOfStock) {
      if (product.stock === 0) {
        return 'Disp. in 24 ore';
      }
      if (product.maxNumInCart) {
        return `Max ${product.maxNumInCart} pezzi`;
      }
      return 'Disponibile';
    }

    // NON VENDE FUORI STOCK
    if (product.stock === 0) {
      return 'In riordino';
    } else if (product.stock === 1) {
      return 'Ultimo pezzo';
    } else if (product.stock < 10) {
      if (product.maxNumInCart && product.maxNumInCart < product.stock) {
        return `Max ${product.maxNumInCart} pezzi`;
      }
      return `Ultimi ${product.stock} pezzi`;
    }

    // NON VENDE FUORI STOCK E STOCK >= 10
    if (product.maxNumInCart) {
      return `Max ${product.maxNumInCart} pezzi`;
    }

    // NON VENDE FUORI STOCK, STOCK >= 10 E NESSUN LIMITE SUI PEZZI ORDINABILI
    if (!!product.catalogue && product.catalogue !== 'C1') {
      // return 'Disp. in 24 ore'; // tolta perchè non desiderata da alcuni store
      return 'Disponibile';
    }

    // NON VENDE FUORI STOCK, STOCK >= 10 E NESSUN LIMITE SUI PEZZI ORDINABILI
    // return null;
    return 'Disponibile';
  }

  renderDiscount = (discount, price, listPrice, secondaryColor, uiVariant) => {
    const discountStyle = css`
      & {
        background-color: ${secondaryColor};
        color: ${primary_s15_l20(secondaryColor)};
      }
      &.variant-1 {
        top: -15px;
        right: -15px;
        width: 60px;
        height: 60px;
        padding: 15px 0;
        font-size: 18px;
        border-radius: 50%;
        letter-spacing: 1px;

        span {
          font-size: 19px;
        }
      }
      &.variant-2 {
        top: -1px;
        right: -1px;
        padding: 0 6px 3px;
        font-size: 14px;
        border-bottom-left-radius: 6px;
        letter-spacing: 0.5px;

        span {
          font-size: 15px;
        }
      }
      &.variant-3 {
        top: 10px;
        right: 20px;
        padding: 0 8px 1px;
        font-size: 14px;
        border-radius: 15px;
        letter-spacing: 0.5px;

        span {
          font-size: 15px;
        }
      }
      &.variant-4 {
        top: -1px;
        right: -1px;
        padding: 0 6px 3px;
        font-size: 14px;
        border-bottom-left-radius: 6px;
        letter-spacing: 0.5px;

        span {
          font-size: 15px;
        }
      }
    `;

    if (discount) {
      return (
        <div className={`discount variant-${uiVariant}`} css={discountStyle}>
          {discount.toFixed(0)}
          <span>%</span>
        </div>
      );
    } else if (listPrice - price > 0) {
      const discountPercent = ((100 * (listPrice - price)) / listPrice)
        .toFixed(0)
        .replace('.', ',');

      return (
        <div className={`discount variant-${uiVariant}`} css={discountStyle}>
          {discountPercent}
          <span>%</span>
        </div>
      );
    }

    return null;
  };

  renderAddToCart = (isSmall = false) => {
    return (
      <A
        href="#"
        className={`add-to-cart ${isSmall ? 'small' : ''} ${
          this.props.maxAddable > 0 ? '' : 'disabled'
        }`}
        onClick={
          this.props.maxAddable
            ? this.addToCart
            : e => {
                e.preventDefault();
              }
        }
      >
        {this.props.maxAddable > 0 ? (
          <React.Fragment>
            <span className="lg-writing">
              {this.props.isInCart
                ? 'Aggiungi un altro'
                : 'Aggiungi al carrello'}
            </span>
            <span className="xs-writing">Aggiungi</span>
            <Cart />
          </React.Fragment>
        ) : (
          <span>In riordino</span>
        )}
      </A>
    );
  };

  addZero = int => {
    return int <= 9 ? `0${int}` : `${int}`;
  };

  renderShippingDay = () => {
    const today = new Date();
    const tomorrow = new Date(today);
    if (this.props.store.features.hasBrtFastShipping) {
      tomorrow.setDate(tomorrow.getDate() + 1);
    } else {
      tomorrow.setDate(tomorrow.getDate() + 2);
    }
    const now = new Date().setUTCHours(
      new Date().getUTCHours() - new Date().getTimezoneOffset() / 60
    );
    const hour = new Date(now).getUTCHours();
    const day = new Date(now).getDay();
    if (this.props.store.features.hasBrtFastShipping) {
      if (day === 5) {
        if (hour < 18) {
          return (
            <span>
              Ricevilo{' '}
              <b className={'shipping-day'}>
                Lunedì {this.addZero(tomorrow.getDate())}
              </b>
            </span>
          );
        } else {
          return (
            <span>
              Ricevilo{' '}
              <b className={'shipping-day'}>
                Martedì {this.addZero(tomorrow.getDate())}
              </b>
            </span>
          );
        }
      } else if (day === 6 || day === 0) {
        if (hour < 18) {
          return (
            <span>
              Ricevilo{' '}
              <b className={'shipping-day'}>
                Martedì {this.addZero(tomorrow.getDate())}
              </b>
            </span>
          );
        } else {
          return (
            <span>
              Ricevilo{' '}
              <b className={'shipping-day'}>
                Mercoledì {this.addZero(tomorrow.getDate())}
              </b>
            </span>
          );
        }
      } else {
        if (hour < 18) {
          return (
            <span>
              Ricevilo <b className={'shipping-day'}>Domani</b>
            </span>
          );
        } else {
          return (
            <span>
              Ricevilo <b className={'shipping-day'}>Dopodomani</b>
            </span>
          );
        }
      }
    } else {
      //non ha la spedizione bartolini in un giorno
      //ordine di venerdì
      if (day === 5 || day === 4) {
        if (hour < 18) {
          return (
            //arrivo lunedì
            <span>
              Ricevilo{' '}
              <b className={'shipping-day'}>
                Lunedì {this.addZero(tomorrow.getDate())}
              </b>
            </span>
          );
        } else {
          return (
            //arrivo martedì
            <span>
              Ricevilo{' '}
              <b className={'shipping-day'}>
                Martedì {this.addZero(tomorrow.getDate())}
              </b>
            </span>
          );
        }
      } else if (day === 6) {
        if (hour < 18) {
          return (
            <span>
              Ricevilo{' '}
              <b className={'shipping-day'}>
                Martedì {this.addZero(tomorrow.getDate())}
              </b>
            </span>
          );
        } else {
          return (
            <span>
              Ricevilo{' '}
              <b className={'shipping-day'}>
                Mercoledì {this.addZero(tomorrow.getDate())}
              </b>
            </span>
          );
        }
      } else if (day === 0) {
        if (hour < 18) {
          return (
            <span>
              Ricevilo{' '}
              <b className={'shipping-day'}>
                Mercoledì {this.addZero(tomorrow.getDate())}
              </b>
            </span>
          );
        } else {
          return (
            <span>
              Ricevilo{' '}
              <b className={'shipping-day'}>
                Giovedì {this.addZero(tomorrow.getDate())}
              </b>
            </span>
          );
        }
      } else {
        if (hour < 18) {
          return (
            <span>
              Ricevilo <b className={'shipping-day'}>Dopodomani</b>
            </span>
          );
        } else if (day === 1) {
          return (
            <span>
              Ricevilo{' '}
              <b className={'shipping-day'}>
                Giovedì {this.addZero(tomorrow.getDate())}
              </b>
            </span>
          );
        } else if (day === 2) {
          return (
            <span>
              Ricevilo{' '}
              <b className={'shipping-day'}>
                Venerdì {this.addZero(tomorrow.getDate())}
              </b>
            </span>
          );
        } else if (day === 3) {
          return (
            <span>
              Ricevilo{' '}
              <b className={'shipping-day'}>
                Lunedì {this.addZero(tomorrow.getDate())}
              </b>
            </span>
          );
        }
      }
    }
  };

  renderFastShippingCountdown = () => {
    const today = new Date();
    const tomorrow = new Date(today);
    tomorrow.setDate(tomorrow.getDate() + 1);

    const now = new Date().setUTCHours(
      new Date().getUTCHours() - new Date().getTimezoneOffset() / 60
    );
    const hour = new Date(now).getUTCHours();
    const day = new Date(now).getDay();

    if (hour < 18) {
      let today = new Date();
      today.setHours(18);
      today.setMinutes(0);
      today.setSeconds(0);

      return <Timer dateEnd={today} home />;
    } else {
      let today = new Date();
      let tomorrow = new Date(today);
      tomorrow.setDate(tomorrow.getDate() + 1);
      tomorrow.setHours(18);
      tomorrow.setMinutes(0);
      tomorrow.setSeconds(0);
      return <Timer dateEnd={tomorrow} home />;
    }
  };

  renderShippingTime = () => {
    return (
      <div style={{ marginTop: 12 }}>
        <div className={'shipping-time'}>
          {this.renderShippingDay()}
          <br />
          Se ordini entro: {this.renderFastShippingCountdown()}
        </div>
      </div>
    );
  };

  renderThummbail = thumbnailStyle => {
    let {
      product,
      siteName,
      primaryColor,
      secondaryColor,
      uiVariantThumbnail,
      uiVariant,
      isCountdown = false,
      productThumbnail,
    } = this.props;

    const uiVariantThumbnailToShow = uiVariant || uiVariantThumbnail;
    const peopleLooking = [0, 0, 0, 1, 1, 2, 2, 2, 3, 3, 3, 4, 4, 5, 5, 6];
    const randomIndex = Math.floor(Math.random() * peopleLooking.length);

    return (
      <div
        className={`product variant-${uiVariantThumbnailToShow} ${
          isCountdown ? 'countdown' : ''
        } ${
          product.discount ? 'special-offer' : ''
        } ${this.renderAvailabilityClass()}`}
        css={thumbnailStyle}
      >
        <div className="visible-content">
          <A
            href={this.getPath()}
            onClick={this.goToProduct}
            className="product-content"
            style={{ color: '#4f4f4f' }}
          >
            <ImageDispatcher
              className={this.props.lazy ? 'lazyload' : ''}
              src={product.image}
              alt={product.imageAltText || `${product.name} - ${siteName}`}
              style={{ objectFit: 'contain' }}
            />

            {this.renderDiscount(
              product.discount,
              product.price,
              product.listPrice,
              secondaryColor,
              uiVariantThumbnailToShow
            )}

            <div className="text-container">
              {uiVariantThumbnailToShow === '4' && (
                <div
                  className="availability"
                  style={{
                    color: primary_s5_l55(primaryColor),
                    fontSize: 12,
                    minHeight: 16,
                    marginBottom: 4,
                  }}
                >
                  {this.renderAvailability()}
                </div>
              )}
              <div className="description">{product.name}</div>
              <div className="price-availability">
                <div className="price-container">
                  <div className="price-difference-container">
                    {!!product.listPrice && product.listPrice > product.price && (
                      <div className="prev-price">
                        <Price amount={product.listPrice} />
                      </div>
                    )}
                    <div className="price">
                      <Price amount={product.price} />
                    </div>
                  </div>
                  {!!product.listPrice && product.listPrice > product.price ? (
                    <div
                      className="saving"
                      style={{ marginTop: 0, color: primaryColor }}
                    >
                      Risparmio{' '}
                      <Price amount={product.listPrice - product.price} />
                    </div>
                  ) : (
                    <div style={{ lineHeight: '18px' }}>&nbsp;</div>
                  )}
                  {!!product.lowestPriceLast30Days && (
                    <div style={{ fontSize: 12, color: '#999', marginTop: 4 }}>
                      Prima era:{' '}
                      <s>
                        <Price amount={product.lowestPriceLast30Days} />
                      </s>
                    </div>
                  )}
                </div>
                {uiVariantThumbnailToShow !== '4' && (
                  <div
                    className="availability"
                    style={{
                      color: primary_s5_l55(primaryColor),
                      fontSize: 12,
                      minHeight: 16,
                      marginTop: 8,
                    }}
                  >
                    {this.renderAvailability()}
                  </div>
                )}
              </div>

              {productThumbnail.shippingTimer && this.renderShippingTime()}

              {isCountdown &&
                productThumbnail.addToCart &&
                uiVariantThumbnailToShow !== '1' &&
                uiVariantThumbnailToShow !== '4' &&
                this.renderAddToCart(true)}
            </div>
          </A>

          {productThumbnail.addToCart &&
            (!isCountdown ||
              (isCountdown && uiVariantThumbnailToShow === '1') ||
              (isCountdown && uiVariantThumbnailToShow === '4')) &&
            this.renderAddToCart()}
        </div>
        <div className="hidden-mobile">
          {peopleLooking[randomIndex] > 0 && (
            <div className="hidden-content">
              {peopleLooking[randomIndex]}{' '}
              {peopleLooking[randomIndex] === 1
                ? 'persona sta'
                : 'persone stanno'}{' '}
              guardando questo prodotto
            </div>
          )}
        </div>
      </div>
    );
  };

  render() {
    let { primaryColor } = this.props;

    const thumbnailStyle = css`
      &.variant-1 {
        &:focus,
        &:hover,
        &.active {
          .visible-content {
            box-shadow: 0 10px 10px 10px ${primary_s20_l70_a025(primaryColor)};
          }
          .add-to-cart {
            background-color: ${primaryColor};
            color: #fff;
          }
        }

        &.countdown {
          .description {
            @media (min-width: 992px) {
              padding-right: 25px;
            }
          }
        }

        .visible-content {
          border-radius: 12px;
        }

        .price-availability {
          flex-direction: row;
          align-items: flex-end;
          justify-content: space-between;

          @media (max-width: 760px) {
            flex-direction: column;
            align-items: flex-start;
          }

          .saving {
            margin: 10px 0 0;
            font-size: 11px;
          }

          .availability {
            text-align: right;
            font-size: 9px;
            text-transform: uppercase;
          }
        }

        .add-to-cart {
          color: '#fff';
          background-color: ${primaryColor};
          font-size: 11px;
          text-transform: uppercase;
          letter-spacing: 1px;
          border-bottom-left-radius: 12px;
          border-bottom-right-radius: 12px;
        }
      }

      &.variant-2 {
        &:focus,
        &:hover,
        &.active {
          .visible-content {
            border: 1px solid ${primary_s5_l90(primaryColor)};
          }
          .add-to-cart {
            background-color: ${primaryColor};
            color: #fff;
          }
        }

        &.countdown {
          .description {
            @media (min-width: 992px) {
              padding-right: 20px;
            }
          }
        }

        .visible-content {
          border: 1px solid ${primary_s5_l90(primaryColor)};
        }

        .price-availability {
          flex-direction: column-reverse;
          align-items: flex-start;
          justify-content: space-between;

          .saving {
            font-size: 10px;
            text-transform: uppercase;

            span {
              font-size: 11px;
            }
          }

          .availability {
            margin-bottom: 10px;
            font-size: 11px;
            min-height: 16px;
          }
        }

        .add-to-cart {
          margin: 0 15px 15px;
          color: '#fff';
          background-color: ${primaryColor};
          font-size: 11px;
          text-transform: uppercase;
          letter-spacing: 1px;

          &.small {
            margin: 20px 0 0;

            @media (min-width: 992px) {
              display: inline-block;
              padding: 10px 20px;
            }
          }
        }
      }

      &.variant-3 {
        &:focus,
        &:hover,
        &.active {
          .visible-content {
            border: 1px solid ${primary_s5_l90(primaryColor)};
          }
          .add-to-cart {
            background-color: ${primaryColor};
            color: #fff;
          }
        }

        &.countdown {
          .price-availability {
            @media (min-width: 992px) {
              align-items: flex-start;
            }
          }

          .description {
            @media (min-width: 992px) {
              padding-right: 42px;
            }
          }

          .shipping-time {
            text-align: left;
          }
        }

        .visible-content {
          border: 1px solid transparent;
        }

        .price-availability {
          flex-direction: column-reverse;
          align-items: center;
          justify-content: center;

          .saving {
            font-size: 10px;
            text-transform: uppercase;

            span {
              font-size: 11px;
            }
          }

          .availability {
            margin-bottom: 10px;
            font-size: 11px;
            min-height: 16px;
          }
        }

        .add-to-cart {
          margin: 0 15px 15px;
          color: #4f4f4f;
          background-color: #fff;
          font-size: 12px;
          border: 1px solid ${primaryColor};
          border-radius: 6px;

          &.small {
            margin: 20px 0 0;

            @media (min-width: 992px) {
              display: inline-block;
              padding: 10px 20px;
            }
          }
        }

        .shipping-time {
          text-align: center;
        }
      }

      &.variant-4 {
        &:focus,
        &:hover,
        &.active {
          .visible-content {
            border: 1px solid ${primary_s5_l90(primaryColor)};
          }
          .add-to-cart {
            background-color: ${primaryColor};
            color: #fff;
          }
        }

        &.countdown {
          .description {
            @media (min-width: 992px) {
              padding-right: 20px;
            }
          }
        }

        .visible-content {
          border: 1px solid ${primary_s5_l90(primaryColor)};
        }

        .price-availability {
          flex-direction: column-reverse;
          align-items: flex-start;
          justify-content: space-between;

          .saving {
            font-size: 11px;
            text-transform: uppercase;

            span {
              font-size: 11px;
            }
          }

          .availability {
            margin-bottom: 10px;
            font-size: 11px;
            min-height: 16px;
          }
        }

        .add-to-cart {
          margin: 0 15px 15px;
          color: '#fff';
          background-color: ${primaryColor};
          font-size: 11px;
          text-transform: uppercase;
          letter-spacing: 1px;

          &.small {
            margin: 20px 0 0;

            @media (min-width: 992px) {
              display: inline-block;
              padding: 10px 20px;
            }
          }
        }

        .shipping-time {
          font-size: 11px;

          .timer {
            font-size: 11px;
          }
        }
      }
    `;

    return <div>{this.renderThummbail(thumbnailStyle)}</div>;
  }
}

function mapStateToProps(state, ownProps) {
  return {
    user: state.user,
    isInCart: isInCart(state, ownProps.product.id),
    quantityInCart: quantityInCart(state, ownProps.product.id),
    maxAddable: getMaxAddable(state, ownProps.product),
    siteName: state.store.data.datiFarmacia.siteName,
    sellProductsOutOfStock:
      state.store.data.funzionalita.sellProductsOutOfStock,
    advancedGa: state.store.data.features.advancedGa,
    hasDynamicRemarketing: state.store.data.features.hasDynamicRemarketing,
    primaryColor: state.store.data.loghiTemplate.brandColor,
    secondaryColor: state.store.data.loghiTemplate.secondaryColor,
    uiVariantThumbnail: state.store.data.uiVariants.thumbnail,
    productThumbnail: state.store.data.loghiTemplate.productThumbnail,
    store: state.store.data,
    products: state.products.data,
    hasGoogleAnalytics4Advanced: !!state.store.data.features
      .hasGoogleAnalytics4Advanced,
    hasGoogleTagManager: !!state.store.data.features.hasGoogleTagManager,
    hasFarmakomMetrics: !!state.store.data.integrazioni.metrics.apiKey,
    hasIubendaCookieSolution:
      state.store.data.features.hasIubendaCookieSolution,
    hasCriteo: state.store.data.features.hasCriteo,
    criteoAccountId: state.store.data.integrazioni.criteo.accountId,
  };
}

ProductThumbnail = withRouter(ProductThumbnail);

export default connect(mapStateToProps, { addToCart })(ProductThumbnail);
